import { Dispatch } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Button, Col, Icon, Modal, Row } from 'common/components'
import { ROUTE_PATHS } from 'common/routePaths'

import './expensePremiumIneligibleModal.less'

type ExpensePremiumIneligibleModalProps = {
  isModalVisible: boolean
  setIsModalVisible: Dispatch<boolean>
}

function ExpensePremiumIneligibleModal({
  isModalVisible,
  setIsModalVisible,
  ...props
}: ExpensePremiumIneligibleModalProps) {
  const { t: eeTranslate } = useTranslation(['ee-dashboard', 'translation'])
  const history = useHistory()

  const onOk = () => {
    setIsModalVisible(false)
  }

  const onCancel = () => {
    setIsModalVisible(false)
    history.push(ROUTE_PATHS.ELIGIBLE_EMPLOYEE_DASHBOARD)
  }

  return (
    <Modal
      closable
      onOk={onOk}
      onCancel={onCancel}
      footer={null}
      visible={isModalVisible}
      destroyOnClose={true}
      className="ineligible-expense-modal"
      width={400}
    >
      <div className="ineligible-expense-modal_body">
        <div className="ineligible-expense-modal_icon mb-24">
          <Icon type="fas fa-exclamation-triangle fa-2x" fontAwesome />
        </div>

        <h4 className="ineligible-expense-modal_title mb-8">
          {eeTranslate('get-reimburse.premium-expense-ineligible-modal.title')}
        </h4>
        <p className="ineligible-expense-modal_description mb-24">
          {eeTranslate('get-reimburse.premium-expense-ineligible-modal.description')}
        </p>

        <div className="ineligible-expense-modal_footer">
          <p className="ineligible-expense-modal_footer-label mb-24">
            {eeTranslate('get-reimburse.premium-expense-ineligible-modal.action-label')}
          </p>

          <Row gutter={8} className="w-100">
            <Col span={12}>
              <Button type="ghost" onClick={onCancel}>
                {eeTranslate('get-reimburse.premium-expense-ineligible-modal.no')}
              </Button>
            </Col>
            <Col span={12}>
              <Button type="primary" onClick={onCancel}>
                {eeTranslate('get-reimburse.premium-expense-ineligible-modal.yes')}
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </Modal>
  )
}

export default ExpensePremiumIneligibleModal
